import { StudioLogger } from '@studio/logger/StudioLogger';
import deleteMeetingAttendee from '@shoflo/studio-redux/actions/attendee/deleteMeetingAttendee';
import toggleProgramSource from '@shoflo/studio-redux/actions/program/toggleProgramSource';
import { BROADCAST_DELETE_SOURCE } from '@shoflo/studio-redux/actions/source/types';
import setProgram from 'actions/program/setProgram';

import { withCurrentParams } from 'utils/actionUtils';
import { CAMERA_PRESENTER, UNASSIGNED } from '@studio/constants/Sources';

const logger = new StudioLogger('Source');

function deleteSource(sourceId) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const action = {
        type: BROADCAST_DELETE_SOURCE,
        request: async apiClient => {
          const {
            broadcastSources,
            program: { layers = [] }
          } = getState();

          const [source] = broadcastSources.sources.filter(
            bs => bs._id === sourceId
          );

          const isSourceInProgram = layers.some(
            layer => layer.source._id === sourceId
          );

          // Remove source from program
          if (isSourceInProgram) {
            dispatch(toggleProgramSource(source, setProgram));
          }

          await apiClient.broadcast.deleteSource(
            teamId,
            eventId,
            broadcastId,
            sourceId
          );

          const logMessage = isSourceInProgram
            ? `Removed sourceId: ${sourceId} from stage and deleted it`
            : `Deleted sourceId: ${sourceId}`;

          logger.info(logMessage, { source });

          // delete attendee from chime meeting
          if (source.type === CAMERA_PRESENTER && source.value !== UNASSIGNED) {
            dispatch(deleteMeetingAttendee(source.value));
          }
          return source;
        }
      };
      dispatch(action);
    }
  );
}

export default deleteSource;
